import { createPortal } from 'react-dom';

/**
 * NOTE: This is a naive portal implementation. If we need something fancier consider this:
 * https://github.com/chakra-ui/chakra-ui/tree/develop/packages/portal
 */

export type PortalProps = {
  children: React.ReactNode;
  /**
   * Where to append the portaled element.
   *   @default document.body
   */
  mountPoint?: Nullable<HTMLElement>;
};

export const Portal = ({
  children,

  mountPoint = document.body as HTMLElement,
}: PortalProps): React.ReactElement | null => {
  if (mountPoint == null) {
    return null;
  }
  return createPortal(children, mountPoint);
};
